"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var LogoContent_1 = __importDefault(require("./LogoContent"));
var ClickableLogo_1 = __importDefault(require("./ClickableLogo"));
exports.default = (function (_a) {
    var classes = _a.classes, link = _a.link, text = _a.text, logoPath = _a.logoPath, alt = _a.alt, rest = __rest(_a, ["classes", "link", "text", "logoPath", "alt"]);
    return (react_1.default.createElement("div", { className: classes.logo }, link ? (react_1.default.createElement(ClickableLogo_1.default, __assign({}, rest, { link: link }))) : (react_1.default.createElement(LogoContent_1.default, __assign({}, rest, { alt: alt, text: text, logoPath: logoPath })))));
});
//# sourceMappingURL=Logo.js.map